import React, { useEffect, useState } from 'react'
import OnboardLayout from '../../components/layout-components/OnboardLayout'
import { REACT_EMPLOYEE_LOGIN_SCREEN, REACT_FUNCTION_KEY_SCREEN } from '../../constants/ReactEndPoints';
import { useNavigate } from 'react-router-dom';
import PasswordField from '../../components/PasswordField';
import { Box, Button, InputAdornment, Typography } from '@mui/material';
import { ReactComponent as VisibilityIcon } from "../../assets/images/VisibilityIcon.svg";
import { ReactComponent as VisibilityOffIcon } from "../../assets/images/VisibilityOffIcon.svg";
import { ReactComponent as LockIcon } from "../../assets/images/lockIcon.svg";
import CommonUtil from '../../util/CommonUtils';
import { updateEmployeeDetails } from '../../services/FunctionKeysService';
import {showMessage } from '../../util/helperFunction';
import { useTranslation } from 'react-i18next';

const ResetPassword = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const [visibility, setVisibility] = useState(true);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConformPassword] = useState("");
  
  const [error, setError] = useState({
    newPassword: "",
    confirmPassword: "",
  });

  useEffect(() => {
    if (
      CommonUtil.isEmptyString(localStorage.getItem('isLoggedIn') + '') ||
      !localStorage.getItem('isLoggedIn')||
      CommonUtil.isEmptyString(localStorage.getItem('employeeNumber'))
    ) {
      navigate(REACT_EMPLOYEE_LOGIN_SCREEN, { replace: true });
    }
  }, [])

  const handleNewPassword = (event) => {
    const value = event.target.value;
    setNewPassword(value);
    setError({
      ...error,
      newPassword: "",
      confirmPassword:""
    });
  };

  const handleConformPassword = (event) => {
    const value = event.target.value;
    setConformPassword(value);
    setError({
      ...error,
      confirmPassword: "",
    });
  };

  const handleCancel= () => {
    navigate(REACT_FUNCTION_KEY_SCREEN);
  };

  const handleSubmit = () => {
    const payload = {
      "data": [
        {
          "employeeNumber": localStorage.getItem('employeeNumber') ,
          "devicePassword": newPassword,
          "updatedDate": new Date().getTime()
        }
      ]
    }

    //Here checking the new password and conform password  Not empty value , both should be matched,and in correct formate
    if (isValidToSubmit()){
      updateEmployeeDetails(payload)
        .then((res) => {
          if (res.status === 201 && res.data?.data.length>0) {
            showMessage("success",t("resetPassword.messages.success"));
            navigate(REACT_FUNCTION_KEY_SCREEN);
          }
        })
        .catch((error) => {
          console.error("Error while updating password",error);
          showMessage("error",'Error while updating password');
        });
    }
  };

  const isValidToSubmit = () => {
    if (newPassword.trim().length === 0) {
      setError({
        ...error,
        newPassword:t("resetPassword.errors.newPasswordRequired"),
      });
      return false;
    }

    if (!CommonUtil.isValidPassword(newPassword)) {
      return false;
    }

    if (confirmPassword.trim().length === 0) {
      setError({
        ...error,
        confirmPassword: t("resetPassword.errors.confirmPasswordRequired"),
      });
      return false;
    }

    if (!CommonUtil.isValidPassword(confirmPassword)) {
      return false;
    }

    if (newPassword !== confirmPassword) {
      setError({
        ...error,
        confirmPassword:t("resetPassword.errors.passwordMismatch"),
      });
      return false;
    }

    return true;
  };

  return (
    <OnboardLayout>
    <Box
     sx={{
       marginTop:"15px",
     }}
     >
      <Box
        sx={{
          display:'flex',
          flexWrap: "wrap",
          justifyContent: "center",
          alignContent: "center",
          paddingBottom:"15px",
        }}
      >
        <Typography variant='resetPasswordTittle'>
         {t("resetPassword.title")}
        </Typography>
      </Box>

      {/* new password */}
      <Box
        sx={{
          flexWrap: "wrap",
          justifyContent: "flex-start",
          alignContent: "center",
          pb:2,
        }}
      >
        <PasswordField
          label={t("resetPassword.labels.newPassword")}
          size="small"
          required
          name="newPassword"
          placeholder={t("resetPassword.placeholders.newPassword")}
          fullWidth
          handleChange={handleNewPassword}
          error={error.newPassword}
          validation="password"
          helperText={error.newPassword}
          type={visibility ? "password" : "text"}
          autoComplete="off"
            inputProps={{
              maxLength:65,
            }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <LockIcon />
              </InputAdornment>
            ),
          }}
        />
      </Box>

      {/* conform password */}
      <Box
        sx={{
          flexWrap: "wrap",
          justifyContent: "flex-start",
          alignContent: "center",
          pb: 1,
        }}
      >
        <PasswordField
          label={t("resetPassword.labels.confirmPassword")}
          size="small"
          required
          name="confirmPassword"
          placeholder={t("resetPassword.placeholders.confirmPassword")}
          fullWidth
          handleChange={handleConformPassword}
          error={error.confirmPassword}
          validation="password"
          helperText={error.confirmPassword}
          type={visibility ? "password" : "text"}
          autoComplete="off"
          inputProps={{
            maxLength:65,
            }}
          InputProps={{
            endAdornment: visibility ? (
              <VisibilityOffIcon
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setVisibility(!visibility);
                }}
              />
            ) : (
              <VisibilityIcon
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setVisibility(!visibility);
                }}
              />
            ),
            startAdornment: (
              <InputAdornment position="start">
                <LockIcon />
              </InputAdornment>
            ),
          }}

        />
      </Box>
      <Box
        sx={{
          display:'flex',
          justifyContent: "space-between",
          gap:"20px",
          alignContent: "center",
          paddingTop: { xs: '20px', sm: "20px", md: '10px', lg: '30px', xl: '40px' },
          pb: 1,
        }}
      >
        <Button
          variant="outlined"
          fullWidth
          onClick={() => {
            handleCancel();
          }}
        >
         {t("resetPassword.buttons.cancel")}
        </Button>
        <Button
          variant="contained"
          fullWidth
          onClick={() => {
            handleSubmit();
          }}
        >
         {t("resetPassword.buttons.submit")}
        </Button>
      </Box>
    </Box>
  </OnboardLayout>
    
  )
}

export default ResetPassword